import * as answers from '../questionRenderers';
import { EAnswerType, EQuestionCode, EQuestionType } from '../../../types/form';
import { CardsQuestionContainer } from '../../CardsQuestionContainer';
import { FioQuestionContainer } from '../../FIOQuestionContainer';
import { CardsChoseQuestionContainer } from '../../CardsChoseQuestionContainer';
import { PhoneVerificationContainer } from '../../PhoneVerificationContainer';
import { RangeQuestionContainer } from '../../RangeQuestionContainer';
import { EmailQuestionContainer } from '../../EmailQuestionContainer';
import { NumberQuestionContainer } from '../../NumberQuestionContainer';
import { PriceQuestionContainer, PriceRangeQuestionContainer } from '../../PriceQuestionContainer';
import { GeoContainer } from '../../GeoContainer';
import { AddressSuggestContainer } from '../../AddressSuggestContainer';
import { LastQuestionContainer } from '../../LastQuestionContainer';
import { QuizCompletedContainer } from '../../QuizCompletedContainer';

export const questionsMapper = (
  code: EQuestionCode,
  type: EQuestionType,
  answerType: EAnswerType,
  isLast?: boolean,
) => {
  if (isLast) {
    return LastQuestionContainer;
  }

  switch (code) {
    case EQuestionCode.Success:
      return QuizCompletedContainer;
    case EQuestionCode.FullName:
      return FioQuestionContainer;
  }

  switch (type) {
    case EQuestionType.Input:
      return answers.InputRenderer;
    case EQuestionType.Address:
      return AddressSuggestContainer;
    case EQuestionType.GeoSuggest:
      return GeoContainer;
    case EQuestionType.Price:
      return answerType === EAnswerType.Range ? PriceRangeQuestionContainer : PriceQuestionContainer;
    case EQuestionType.Email:
      return EmailQuestionContainer;
    case EQuestionType.Phone:
      return PhoneVerificationContainer;
    case EQuestionType.Number:
      return NumberQuestionContainer;
    case EQuestionType.OneChoice:
      return CardsQuestionContainer;
    case EQuestionType.MultiChoice:
      return CardsChoseQuestionContainer;
    case EQuestionType.Range:
      return RangeQuestionContainer;
  }
};
